import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import React, { useContext } from 'react';
import { CircularProgress, Box } from '@mui/material';
import AlertMessagesProvider from 'react-alert-messages';
import './App.css';
import DashboardPage from './components/pages/Dashboard/Dashboard';
import SettingsPage from './components/pages/Settings/SettingsPage';
import StockReportPage from './components/pages/stock/StockReport';
import StockDamagePage from './components/pages/StockDamage/StockDamage';
import NewStockDamagePage from './components/pages/StockDamage/NewStockDamage';
import ItemSummaryReportPage from './components/pages/Report/ItemSummary';
import PaymentModeSummaryReportPage from './components/pages/Report/PaymentModeSummaryReport';
import ItemisedBillSummaryReportPage from './components/pages/Report/ItemisedBill';
import BillSummaryReportPage from './components/pages/Report/BillSummary';
import ProfitBillSummaryReportPage from './components/pages/Report/ProfitBillSummary';
import ProfitItemSummaryReportPage from './components/pages/Report/ProfitItemSummary';
import ProfitItemisedBillSummaryReportPage from './components/pages/Report/ProfitItemisedBill';
import ProfitDayWiseReport from './components/pages/Report/ProfitDayWiseReport';
import DayWiseReport from './components/pages/Report/DayWiseReport';
import LoginPage from './components/pages/Login/Login';
import ForgetPasswordPage from './components/pages/Login/ForgetPassword';
import NewAccountPage from './components/pages/Register/NewAccount';
import PlansPage from './components/pages/Login/Plans';
import ItemsListPage from './components/pages/Products/ItemsList';
import ItemDetailsPage from './components/pages/Products/ItemDetails';
import ItemsCategoriesPage from './components/pages/Products/ItemsCategries';
import DevicesPage from './components/pages/Devices/Devices';
import TerminalPage from './components/pages/Terminals/Terminals';
import PurchaseHistoryPage from './components/pages/Purchase/PurchaseHistory';
import AddPurchasePage from './components/pages/Purchase/AddPurchase';
import SubscriptionPage from './components/pages/Subscription&Payment/Subscription';
import PermissionDetail from './components/pages/Settings/PermissionDetail';
import PaymentCallbackPage from './components/pages/Subscription&Payment/PaymentCallback';
import CustomersPage from './components/pages/Customers/Customers';
import SalesPersonPage from './components/pages/SalesPerson';
import TablesPage from './components/pages/Tables';
import ExpensesPage from './components/pages/Expenses/Expenses';
import PageNotFound from './components/pages/Error/PageNotFound';
import PrivateRoute from './components/utils/PrivateRoute';
import SelectedTabProvider from './Context/SelectedTabContext';
import ShopProvider, { ShopContext } from './Context/ShopContext';
import UserProvider from './Context/UserContext';
import InventoryProvider from 'Context/InventoryContext';
import MultiShopDashboard from './components/pages/Dashboard/MultiShopDashboard';
import WarehouseProvider from 'Context/WarehouseContext';
import { ROUTES } from './const';
import CustomerDetailsPage from './components/pages/Customers/CustomerDetails';
import VendorsPage from './components/pages/Vendors/Vendors';
import VendorDetailsPage from './components/pages/Vendors/VendorDetails';
import ThemeProvider from './Context/ThemeContext';
import OnlinePurchaseProvider from './Context/OnlinePurchaseContext';
import BillFormatProvider from './Context/BillFormatContext';
import TerminalProvider from './Context/TerminalContext';
import OnboardingPage from './components/pages/Login/Onboarding';
import AppSetupPage from './components/pages/Login/AppSetup';
import RegisterSuccess from './components/pages/Login/RegisterSuccess';
import DynamicHeader from './components/utils/DynamicHeader/DynamicHeader';
import TerminalSettingsPage from './components/pages/Terminals/TerminalSettings';
import PricingPage from './components/pages/Register/RegisterPlan';
import AddonPage from './components/pages/Register/Addon';
import PaymentProcessingPage from './components/pages/Register/PaymentProcessing';
import PaymentStatusPage from './components/pages/Register/PaymentStatus';
import StaffSalesReport from './components/pages/Report/StaffSalesReport';
import StaffProductSalesReport from './components/pages/Report/StaffProductSalesReport';
import CategorySalesReport from './components/pages/Report/CategorySalesReport';
import ReturnedSalesSummary from './components/pages/Report/ReturnedSalesSummary';
import ReturnedItemSummary from './components/pages/Report/ReturnedItemSummary';
import ReturnedBillItemSummary from './components/pages/Report/ReturnedBillItemSummary';
import PurchaseSummary from './components/pages/Report/PurchaseSummary';
import PurchaseItemSummary from './components/pages/Report/PurchaseItemSummary';
import VendorPurchaseSummary from './components/pages/Report/VendorPurchaseSummary';
import SalesTaxSummary from './components/pages/Report/SalesTaxSummary';
import PurchaseTaxSummary from './components/pages/Report/PurchaseTaxSummary';
import HSNSummaryReport from './components/pages/Report/HSNSummaryReport';
import OrderTypeSummary from './components/pages/Report/OrderTypeSummary';
import CustomerGroupPage from './components/pages/Customers/CustomerGroup';
import OrderActionsPage from './components/pages/OrderActions/OrderActions';
import AddSalesPage from './components/pages/Sales/AddSales';
import AddEstimatePage from './components/pages/Estimates/AddEstimate';
import ShiftReportSummaryPage from './components/pages/Shifts/ShiftSummary';
import PurchaseReturnHistoryPage from './components/pages/PurchaseReturn/PurchaseReturnHistory';
import AddPurchaseReturnPage from './components/pages/PurchaseReturn/AddPurchaseReturn';
import RenewPlanPage from './components/pages/RenewPlan/RenewPlan';
import ProductionPage from './components/pages/Production/Production.js';
import ProductionHistoryPage from './components/pages/Production/ProductionHistory.js';
import ManualStockAdjustmentPage from './components/pages/Report/ManualStockAdjReport.js';
import StockSummarReport from './components/pages/Report/StockSummaryReport';
import ShiftsPage from './components/pages/Shifts/Shifts.js';
import SalespersonReport from 'components/pages/Report/SalespersonReport';
import SalespersonItemWiseReport from 'components/pages/Report/SalespersonItemWiseReport';
import SalespersonDetailedReport from 'components/pages/Report/SalespersonDetailedReport';
import OnlineOrders from 'components/pages/OnlineOrders/OnlineOrders';
import OnlineOrderDetails from 'components/pages/OnlineOrders/OnlineOrderDetails';
import CustomerOutstandingReport from 'components/pages/Report/CustomerOutstandingReport';
import CustomerPaymentReport from 'components/pages/Report/CustomerPaymentReport';
import AllPartyReport from 'components/pages/Report/AllPartyReport';
import StockTransferPage from 'components/pages/StockTransfer/StockTransfer';
import NewStockTransferPage from 'components/pages/StockTransfer/NewStockTransfer';
import InternalStockTransferPage from 'components/pages/StockTransfer/InternalStockTransfer';
import NewInternalStockTransferPage from 'components/pages/StockTransfer/NewInternalStockTransfer';
import NcSalesSummaryReportPage from 'components/pages/Report/NcSalesSummary';
import CustomerNcReportPage from './components/pages/Report/CustomerNcReport';
import EstimateReportPage from './components/pages/Report/EstimateReport';
import AccountHeadsPage from './components/pages/Accounts/AccountHeads';
import AccountLedgerPage from './components/pages/Accounts/AccountLedger';
import ItemStockExpiringReport from './components/pages/Report/ItemStockExpiringReport';
import ItemStockExpiredReport from './components/pages/Report/ItemStockExpiredReport';
import WarehousesPage from './components/pages/Warehouses/Warehouses';
import WarehouseStockPage from './components/pages/Warehouses/WarehouseStock';
import FeedbackManagementPage from './components/pages/Feedback/FeedbackManagement';
import PublicFeedbackForm from './components/pages/Feedback/PublicFeedbackForm';

const DashboardRouter = () => {
  const { shops } = useContext(ShopContext);

  if (shops === null) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (shops && shops.length > 1) {
    return <Redirect to={ROUTES.MULTI_SHOP_DASHBOARD} />;
  }

  return <Redirect to={ROUTES.DASHBOARD} />;
};

function App() {
  return (
    <AlertMessagesProvider>
      <ThemeProvider>
        <DynamicHeader />
        <Router>
          <SelectedTabProvider>
            <OnlinePurchaseProvider>
              <Switch>
                <Route exact path={ROUTES.ANY} component={LoginPage} />
                <Route exact path={ROUTES.CONSOLE} component={LoginPage} />
                <Route exact path={ROUTES.LOGIN} component={LoginPage} />
                <Route exact path={ROUTES.RESET_PASSWORD} component={ForgetPasswordPage} />
                <Route exact path={ROUTES.ONBOARDING} component={OnboardingPage} />
                <Route exact path={ROUTES.APP_SETUP} component={AppSetupPage} />
                <Route exact path={ROUTES.SHOP_CREATED} component={RegisterSuccess} />
                <Route exact path={ROUTES.PAGE_404} component={PageNotFound} />
                <Route exact path={ROUTES.SIGNUP} component={NewAccountPage} />
                <Route exact path={ROUTES.PLANS} component={PlansPage} />
                <Route exact path={ROUTES.PRICING} component={PricingPage} />
                <Route exact path={ROUTES.ADD_ONS} component={AddonPage} />
                <Route exact path={ROUTES.PROCESS_PAYMENT} component={PaymentProcessingPage} />
                <Route exact path={ROUTES.PAYMENT_STATUS} component={PaymentStatusPage} />
                <Route exact path={ROUTES.PUBLIC_FEEDBACK} component={PublicFeedbackForm} />
                <ShopProvider>
                  <UserProvider>
                    <TerminalProvider>
                      <BillFormatProvider>
                        <InventoryProvider>
                          <WarehouseProvider>
                            <PrivateRoute exact path={ROUTES.MULTI_SHOP_DASHBOARD} component={MultiShopDashboard} />
                            <PrivateRoute exact path={ROUTES.DASHBOARD} component={DashboardPage} />
                            <PrivateRoute exact path={ROUTES.HOME} component={DashboardRouter} />
                            <PrivateRoute exact path={ROUTES.ITEMS} component={ItemsListPage} />
                            <PrivateRoute exact path={ROUTES.ITEM_DETAILS} component={ItemDetailsPage} />
                            <PrivateRoute exact path={ROUTES.CATEGORIES} component={ItemsCategoriesPage} />
                            <PrivateRoute exact path={ROUTES.DEVICES} component={DevicesPage} />
                            <PrivateRoute exact path={ROUTES.TERMINALS} component={TerminalPage} />
                            <PrivateRoute exact path={ROUTES.TERMINAL_SETTINGS} component={TerminalSettingsPage} />
                            <PrivateRoute exact path={ROUTES.CUSTOMERS} component={CustomersPage} />
                            <PrivateRoute exact path={ROUTES.CUSTOMER_GROUP} component={CustomerGroupPage} />
                            <PrivateRoute exact path={ROUTES.CUSTOMER_DETAILS} component={CustomerDetailsPage} />
                            <PrivateRoute exact path={ROUTES.VENDORS} component={VendorsPage} />
                            <PrivateRoute exact path={ROUTES.VENDOR_DETAILS} component={VendorDetailsPage} />
                            <PrivateRoute exact path={ROUTES.SALES_PERSON} component={SalesPersonPage} />
                            <PrivateRoute exact path={ROUTES.TABLES} component={TablesPage} />
                            <PrivateRoute exact path={ROUTES.MANAGE_SALES} component={AddSalesPage} />
                            <PrivateRoute exact path={ROUTES.ESTIMATES} component={AddEstimatePage} />
                            <PrivateRoute exact path={ROUTES.PURCHASE_HISTORY} component={PurchaseHistoryPage} />
                            <PrivateRoute exact path={ROUTES.NEW_PRODUCTION} component={ProductionPage} />
                            <PrivateRoute exact path={ROUTES.PRODUCTION_HISTORY} component={ProductionHistoryPage} />
                            <PrivateRoute exact path={ROUTES.NEW_PURCHASE} component={AddPurchasePage} />
                            <PrivateRoute exact path={ROUTES.EDIT_PURCHASE} component={AddPurchasePage} />
                            <PrivateRoute
                              exact
                              path={ROUTES.PURCHASE_RETURN_HISTORY}
                              component={PurchaseReturnHistoryPage}
                            />
                            <PrivateRoute exact path={ROUTES.NEW_PURCHASE_RETURN} component={AddPurchaseReturnPage} />
                            <PrivateRoute exact path={ROUTES.EDIT_PURCHASE_RETURN} component={AddPurchaseReturnPage} />
                            <PrivateRoute exact path={ROUTES.EXPENSES} component={ExpensesPage} />
                            <PrivateRoute exact path={ROUTES.DAMAGE_HISTORY} component={StockDamagePage} />
                            <PrivateRoute exact path={ROUTES.ORDER_ACTIONS} component={OrderActionsPage} />
                            <PrivateRoute exact path={ROUTES.NEW_DAMAGE} component={NewStockDamagePage} />
                            <PrivateRoute exact path={ROUTES.STOCK_TRANSFER} component={StockTransferPage} />
                            <PrivateRoute exact path={ROUTES.NEW_STOCK_TRANSFER} component={NewStockTransferPage} />
                            <PrivateRoute exact path={ROUTES.EDIT_STOCK_TRANSFER} component={NewStockTransferPage} />
                            <PrivateRoute exact path={ROUTES.INTERNAL_STOCK_TRANSFER} component={InternalStockTransferPage} />
                            <PrivateRoute exact path={ROUTES.NEW_INTERNAL_STOCK_TRANSFER} component={NewInternalStockTransferPage} />
                            <PrivateRoute exact path={ROUTES.EDIT_INTERNAL_STOCK_TRANSFER} component={NewInternalStockTransferPage} />
                            <PrivateRoute exact path={ROUTES.ITEM_SUMMARY} component={ItemSummaryReportPage} />
                            <PrivateRoute exact path={ROUTES.ITEMISED_BILL} component={ItemisedBillSummaryReportPage} />
                            <PrivateRoute exact path={ROUTES.BILL_SUMMARY} component={BillSummaryReportPage} />
                            <PrivateRoute
                              exact
                              path={ROUTES.PAYMENT_MODE_REPORT}
                              component={PaymentModeSummaryReportPage}
                            />
                            <PrivateRoute
                              exact
                              path={ROUTES.PROFIT_ITEM_SUMMARY}
                              component={ProfitItemSummaryReportPage}
                            />
                            <PrivateRoute exact path={ROUTES.STAFF_SALES_REPORT} component={StaffSalesReport} />
                            <PrivateRoute
                              exact
                              path={ROUTES.STAFF_PRODUCT_SALES_REPORT}
                              component={StaffProductSalesReport}
                            />
                            <PrivateRoute exact path={ROUTES.CATEGORY_SALES_REPORT} component={CategorySalesReport} />
                            <PrivateRoute exact path={ROUTES.RETURNED_BILL_SUMMARY} component={ReturnedSalesSummary} />
                            <PrivateRoute exact path={ROUTES.RETURNED_ITEM_SUMMARY} component={ReturnedItemSummary} />
                            <PrivateRoute
                              exact
                              path={ROUTES.RETURNED_SALE_ITEM_SUMMARY}
                              component={ReturnedBillItemSummary}
                            />
                            <PrivateRoute
                              exact
                              path={ROUTES.MANUAL_STOCK_ADJUSTMENT_REPORT}
                              component={ManualStockAdjustmentPage}
                            />
                            <PrivateRoute
                              exact
                              path={ROUTES.ITEM_STOCK_EXPIRING_REPORT}
                              component={ItemStockExpiringReport}
                            />
                            <PrivateRoute
                              exact
                              path={ROUTES.ITEM_STOCK_EXPIRED_REPORT}
                              component={ItemStockExpiredReport}
                            />
                            <PrivateRoute exact path={ROUTES.PURCHASE_SUMMARY} component={PurchaseSummary} />
                            <PrivateRoute exact path={ROUTES.PURCHASE_ITEM_SUMMARY} component={PurchaseItemSummary} />
                            <PrivateRoute exact path={ROUTES.VENDON_PURCHASE_SUMMARY} component={VendorPurchaseSummary} />
                            <PrivateRoute exact path={ROUTES.SALES_TAX_SUMMARY} component={SalesTaxSummary} />
                            <PrivateRoute exact path={ROUTES.PURCHASE_TAX_SUMMARY} component={PurchaseTaxSummary} />
                            <PrivateRoute exact path={ROUTES.HSN_SUMMARY} component={HSNSummaryReport} />
                            <PrivateRoute exact path={ROUTES.SHIFTS} component={ShiftsPage} />
                            <PrivateRoute exact path={ROUTES.SHIFT_SUMMARY} component={ShiftReportSummaryPage} />
                            <PrivateRoute exact path={ROUTES.ORDER_TYPE_SALES_REPORT} component={OrderTypeSummary} />
                            <PrivateRoute
                              exact
                              path={ROUTES.PROFIT_ITEMISED_BILL}
                              component={ProfitItemisedBillSummaryReportPage}
                            />
                            <PrivateRoute
                              exact
                              path={ROUTES.PROFIT_BILL_SUMMARY}
                              component={ProfitBillSummaryReportPage}
                            />
                            <PrivateRoute exact path={ROUTES.DAY_WISE_REPORT} component={DayWiseReport} />
                            <PrivateRoute exact path={ROUTES.PROFIT_DAY_WISE_REPORT} component={ProfitDayWiseReport} />
                            <PrivateRoute exact path={ROUTES.STOCK_CHANGE_REPORT} component={StockReportPage} />
                            <PrivateRoute
                              exact
                              path={ROUTES.CUSTOMER_OUTSTANDING_REPORT}
                              component={CustomerOutstandingReport}
                            />
                            <PrivateRoute exact path={ROUTES.WAREHOUSES} component={WarehousesPage} />
                            <PrivateRoute exact path={ROUTES.WAREHOUSE_STOCK} component={WarehouseStockPage} />
                            <PrivateRoute exact path={ROUTES.CUSTOMER_PAYMENT_REPORT} component={CustomerPaymentReport} />
                            <PrivateRoute exact path={ROUTES.ALL_PARTY_REPORT} component={AllPartyReport} />
                            <PrivateRoute exact path={ROUTES.NC_SALES_REPORT} component={NcSalesSummaryReportPage} />
                            <PrivateRoute exact path={ROUTES.NC_CUSTOMER_REPORT} component={CustomerNcReportPage} />
                            <PrivateRoute exact path={ROUTES.ESTIMATE_REPORT} component={EstimateReportPage} />
                            <PrivateRoute exact path={ROUTES.STOCK_SUMMARY} component={StockSummarReport} />
                            <PrivateRoute exact path={ROUTES.SETTINGS} component={SettingsPage} />
                            <PrivateRoute exact path={ROUTES.SETTINGS_TAB} component={SettingsPage} />
                            <PrivateRoute exact path={ROUTES.SETTINGS_SUB_TAB} component={SettingsPage} />
                            <PrivateRoute exact path={ROUTES.SUBSCRIPTION_PLANS} component={SubscriptionPage} />
                            <PrivateRoute exact path={ROUTES.PERMISSION_DETAIL} component={PermissionDetail} />
                            <PrivateRoute exact path={ROUTES.PAYMENT_CALLBACK} component={PaymentCallbackPage} />
                            <PrivateRoute exact path={ROUTES.RENEW_PLAN} component={RenewPlanPage} />
                            <PrivateRoute exact path={ROUTES.ONLINE_ORDERS} component={OnlineOrders} />
                            <PrivateRoute exact path={ROUTES.ONLINE_ORDER_DETAILS} component={OnlineOrderDetails} />
                            <PrivateRoute exact path={ROUTES.STOCK_REPORT} component={StockReportPage} />
                            <PrivateRoute exact path={ROUTES.ACCOUNT_HEADS} component={AccountHeadsPage} />
                            <PrivateRoute exact path={ROUTES.ACCOUNT_LEDGER} component={AccountLedgerPage} />
                            <PrivateRoute exact path={ROUTES.SERVICE_STAFF_REPORT} component={SalespersonReport} />
                            <PrivateRoute
                              exact
                              path={ROUTES.SERVICE_STAFF_ITEM_WISE_REPORT}
                              component={SalespersonItemWiseReport}
                            />
                            <PrivateRoute
                              exact
                              path={ROUTES.SERVICE_STAFF_DETAILED_REPORT}
                              component={SalespersonDetailedReport}
                            />
                            <PrivateRoute exact path={ROUTES.FEEDBACK_MANAGEMENT} component={FeedbackManagementPage} />
                          </WarehouseProvider>
                        </InventoryProvider>
                      </BillFormatProvider>
                    </TerminalProvider>
                  </UserProvider>
                </ShopProvider>
                <Route path="/*">
                  <Redirect to={ROUTES.PAGE_404} />
                </Route>
              </Switch>
            </OnlinePurchaseProvider>
          </SelectedTabProvider>
        </Router>
      </ThemeProvider>
    </AlertMessagesProvider>
  );
}

export default App;